import React, { useState, useEffect, useRef } from 'react';
import { Input, Modal, Form, Upload, message, Spin } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import moment from 'moment';//日期格式化导包
import NewMessage from '../../component/newMessage/newMessage';
import { Config } from '../../public/js/config';
import { Base } from '../../public/js/base';
import { ContextHandler } from '../../public/js/contextHandler';
import { useHistory } from 'react-router-dom';

import './partnerDetail.css';

import saveImg from '../../public/img/newMain/Save.png';
import { partnerCheckLogin } from '../newMain/partnerMain';
import VerificationCodeModal from './verificationCodeModal';

const { TextArea } = Input;
const ClassicEditor = window.ClassicEditor;

const PartnerDetail = (props) => {

    const messageRef = useRef();
    const [form] = Form.useForm();
    const [isLoad, setIsLoad] = useState(false);
    const [imageFile, setImageFile] = useState([]);
    const [previewVisible, setPreviewVisible] = useState(false);
    const [isVerificationCodeModal, setIsVerificationCodeModal] = useState(false);
    const [isCheckModifyEmail, setIsCheckModifyEmail] = useState(true);
    const [previewImage, setPreviewImage] = useState(null);
    const [partnerModel, setPartnerModel] = useState({});
    const [ckeditor, setCkeditor] = useState(null);
    const [deptList, setDeptList] = useState([]);
    const imageNum = 1;
    const history = useHistory();
    const smsCodeModel = useRef({});

    useEffect(() => {
        if (!Config.partnerInfo?.partnerId) {
            partnerCheckLogin();
        }
        searchDept();
        searchById(Config.partnerInfo?.partnerId);
    }, []);

    const searchDept = () => {
        Base.callBackApi('commonDropDown/searchAllDept').then((data) => {
            if ("SUCCESS" == data.msg) {
                setDeptList(data?.object ?? []);
            } else {
                message.error(data.msg)
            }
        }).catch(err => { });
    }

    const searchById = (partnerId) => {
        Base.callBackApi("partnerDetail/searchById", {'partnerId': partnerId}).then(async (data) => {
            if ("SUCCESS" === data.msg) {
                let model = data.object ?? {};
                let file = [];
                if (model.companyLogo) {
                    file.push({
                        url: Config.partnerImg + model.companyLogo + '?' + Config.sasToken,
                        originUrl: model.companyLogo,
                        imgStatus: "OLD"
                    })
                }
                setImageFile(file);
                initForm(model);
                if (Base.isEmpty(ckeditor)) {
                    const editor = await ClassicEditor.create(document.querySelector('#editor'), { ...Config.ckEditorConfigWebsite, placeholder: 'To be provided by Industry Partner' });
                    editor.setData(model?.companyProfile ?? "");
                    setCkeditor(editor);
                } else {
                    ckeditor.setData(model?.companyProfile ?? "");
                }
                Config.partnerInfo.companyLocation = model.companyLocation
                Config.partnerInfo.companyLogo = model.companyLogo
                Config.partnerInfo.companyName = model.companyName
                Config.partnerInfo.companyProfile = model.companyProfile
                Config.partnerInfo.companySocailMedia = model.companySocailMedia
                Config.partnerInfo.companyWebsite = model.companyWebsite
                Config.partnerInfo.companyYouTuBe = model.companyYouTuBe
                Config.partnerInfo.partnerId = model.partnerId
                setPartnerModel(model)
            } else {
                message.error(data.msg)
            }
        })
    }

    const initForm = (model = {}) => {
        form.resetFields();
        form.setFieldsValue({
            companyName: model.companyName ?? "",
            companyWebsite: model.companyWebsite ?? "",
            companySocailMedia: model.companySocailMedia ?? "",
            companyYouTuBe: model.companyYouTuBe ?? "",
            companyLocation: model.companyLocation ?? "",
            companyInstagram: model.companyInstagram ?? "",
            companyFacebook: model.companyFacebook ?? "",
            companyWeChat: model.companyWeChat ?? "",
            other: model.other ?? "",
            hkBusinessRegNo: model.hkBusinessRegNo ?? "",
            contactName: model.contactName ?? "",
            contactTitle: model.contactTitle ?? "",
            contactOfficePhone: model.contactOfficePhone ?? "",
            contactMobilePhone: model.contactMobilePhone ?? "",
            contactEmail: model.contactEmail ?? "",
            contactDept: model.contactDept ?? "",
            theiDeptId: model.theiDeptId ?? "",
            theiContactName: model.theiContactName ?? "",
        });
    }

    const update = () => {
        form.submit();
    }

    const onFinish = (values) => {
        if (isLoad) {
            return;
        }
        values.companyProfile = ckeditor.getData();
        if (!values.companyProfile) {
            message.error("Company Description is required.");
            return;
        }
        if (values.contactEmail !== partnerModel.contactEmail && isCheckModifyEmail) {
            setIsCheckModifyEmail(false)
            setIsVerificationCodeModal(true)
            return
        }
        values.smsCode = smsCodeModel.current.smsCode;
        values.partnerId = partnerModel.partnerId;
        values.lastUpdatedDate = partnerModel.lastUpdatedDate;
        values.activeInd = partnerModel.activeInd;
        values.partnerContactAcctId = partnerModel.partnerContactAcctId;
        if (imageFile && imageFile.length > 0) {
            values.companyLogoModel = {
                status: imageFile[0].imgStatus,
                url: imageFile[0].originUrl,
            };
        }
        setIsLoad(true);
        Base.callBackApi("partnerDetail/update", values).then((data) => {
            if ("SUCCESS" === data.msg) {
                opendialog("You've successfully updated Company Profile.");
            } else {
                message.error(data.msg)
            }
        }).catch(err => { }).finally(() => {
            setIsLoad(false)
            setIsCheckModifyEmail(true)
        });
    }

    const opendialog = (param) => {
        messageRef.current.setContent(param)
        messageRef.current.setIsShow(true)
    }

    const done = () => {
        messageRef.current.setIsShow(false);
        searchById(Config.partnerInfo?.partnerId);
    }

    const checkImg = (value) => {
        if (!!imageFile && imageFile.length > 0 && !!value) {
            let list = value.fileList;
            if (list.find(item => item.status === "uploading")) {
                return Promise.reject("Please wait for uploading the photo.");
            }
            if (list.find(item => item.status === "error")) {
                return Promise.reject("Please handle the failed images first.");
            }
        }
        return Promise.resolve();
    }

    const handleChangeImg = (file) => {
        let fileList = file.fileList;
        file = file.file;
        if (file.status === "removed") {
            let index = imageFile.findIndex(item => item.uid == file.uid);
            let fileList = JSON.parse(JSON.stringify(imageFile));
            fileList.splice(index, 1)
        } else {
            const reader = new FileReader();
            reader.readAsDataURL(file.originFileObj);
            reader.onload = (e) => {
                fileList[fileList.length - 1].originUrl = e.target.result;
                fileList[fileList.length - 1].imgStatus = "NEW";
            }
        }
        setImageFile(fileList);
    }

    /**关闭图片弹窗 */
    const handleCancel = () => {
        setPreviewVisible(false);
    }

    const handlePreview = (file) => {
        setPreviewImage(file.url || file.thumbUrl);
        setPreviewVisible(true);
    }

    const uploadButton = (
        <div>
            <PlusOutlined />
            <div>Upload Photo</div>
        </div>
    );

    const jump = (path) => {
        history.push(path)
    }

    const closeVerificationCodeModal = (flag, smsCode) => {
        if(flag) {
            smsCodeModel.current = {'smsCode': smsCode};
            form.submit()
        } else {
            setIsCheckModifyEmail(true)
        }
        setIsVerificationCodeModal(false)
    }

    return (
        <div id="container" className='websiteTemplate partnerDetail'>
            <NewMessage ref={messageRef} done={done} />
            {isVerificationCodeModal && <VerificationCodeModal partnerModel={partnerModel} onClose={closeVerificationCodeModal}/>}
            <Spin size="large" spinning={isLoad} >
                <Form form={form} onFinish={onFinish}>
                    <div className='websiteSysButtonRow'>
                        <div className="detailTitle">Company Profile</div>
                        <div className="websiteSysButtonBox">
                            <div className='websiteSysButton ' onClick={() => jump('/partner/partnerChangePassword')}>Change Password</div>
                            <div className='websiteSysButton' onClick={() => update()}><img src={saveImg} />Save</div>
                        </div>
                    </div>
                    <div className="websiteSysContentBox">
                        <div className="websiteSysRow">
                            <div className="websiteSysCol">
                                <div className="websiteSysParam mustFill">Company Name</div>
                                <div className="websiteSysInput">
                                    <Form.Item
                                        name="companyName"
                                        rules={[
                                            { required: true, message: "Company Name is required." },
                                        ]}
                                    >
                                        <Input type="text" placeholder="Company Name" maxLength={50} disabled/>
                                    </Form.Item>
                                </div>
                            </div>
                            <div className="websiteSysCol">
                                <div className="websiteSysParam">Company Website</div>
                                <div className="websiteSysInput">
                                    <Form.Item
                                        name="companyWebsite"
                                        rules={[
                                            { required: false },
                                        ]}
                                    >
                                        <Input type="text" placeholder="Company Website" maxLength={200} />
                                    </Form.Item>
                                </div>
                            </div>
                        </div>
                        <div className="websiteSysRow">
                            <div className="websiteSysCol">
                                <div className="websiteSysParam">Company LinkedIn</div>
                                <div className="websiteSysInput">
                                    <Form.Item
                                        name="companySocailMedia"
                                        rules={[
                                            { required: false },
                                        ]}
                                    >
                                        <Input type="text" placeholder="Company LinkedIn" maxLength={200} />
                                    </Form.Item>
                                </div>
                            </div>
                            <div className="websiteSysCol">
                                <div className="websiteSysParam">Company YouTube</div>
                                <div className="websiteSysInput">
                                    <Form.Item
                                        name="companyYouTuBe"
                                        rules={[
                                            { required: false },
                                        ]}
                                    >
                                        <Input type="text" placeholder="Company YouTube" maxLength={200} />
                                    </Form.Item>
                                </div>
                            </div>
                        </div>
                        <div className="websiteSysRow">
                            <div className="websiteSysCol">
                                <div className="websiteSysParam">Company Instagram</div>
                                <div className="websiteSysInput">
                                    <Form.Item
                                        name="companyInstagram"
                                        rules={[
                                            { required: false },
                                        ]}
                                    >
                                        <Input type="text" placeholder="Company Instagram" maxLength={200} />
                                    </Form.Item>
                                </div>
                            </div>
                            <div className="websiteSysCol">
                                <div className="websiteSysParam">Company Facebook</div>
                                <div className="websiteSysInput">
                                    <Form.Item
                                        name="companyFacebook"
                                        rules={[
                                            { required: false },
                                        ]}
                                    >
                                        <Input type="text" placeholder="Company Facebook" maxLength={200} />
                                    </Form.Item>
                                </div>
                            </div>
                        </div>
                        <div className="websiteSysRow">
                            <div className="websiteSysCol">
                                <div className="websiteSysParam">Company WeChat</div>
                                <div className="websiteSysInput">
                                    <Form.Item
                                        name="companyWeChat"
                                        rules={[
                                            { required: false },
                                        ]}
                                    >
                                        <Input type="text" placeholder="Company WeChat" maxLength={200} />
                                    </Form.Item>
                                </div>
                            </div>
                            <div className="websiteSysCol">
                                <div className="websiteSysParam">Other</div>
                                <div className="websiteSysInput">
                                    <Form.Item
                                        name="other"
                                        rules={[
                                            { required: false },
                                        ]}
                                    >
                                        <Input type="text" placeholder="Other" maxLength={200} />
                                    </Form.Item>
                                </div>
                            </div>
                        </div>
                        <div className="websiteSysRow">
                            <div className="websiteSysCol">
                                <div className="websiteSysParam">Hong Kong Business Registration Number</div>
                                <div className="websiteSysInput">
                                    <Form.Item
                                        name="hkBusinessRegNo"
                                        rules={[
                                            { required: false },
                                        ]}
                                    >
                                        <Input type="text" placeholder="Hong Kong Business Registration Number" maxLength={20} />
                                    </Form.Item>
                                </div>
                            </div>
                            <div className="websiteSysCol">
                                <div className="websiteSysParam">Company Logo</div>
                                <div className="websiteSysInput">
                                    <Modal title="" visible={previewVisible} footer={null} onCancel={handleCancel}>
                                        <img alt="example" style={{ width: '100%' }} src={previewImage} />
                                    </Modal>
                                    <Form.Item
                                        name="companyLog"
                                        rules={[
                                            { validator: (rule, value) => checkImg(value) }
                                        ]}
                                    >
                                        <Upload
                                            action={Config.uploadTestServer}
                                            key={"1"}
                                            accept=".png, .jpg, .jpeg"
                                            listType="picture-card"
                                            fileList={imageFile}
                                            onPreview={handlePreview}
                                            onChange={(file) => handleChangeImg(file)}>
                                            {imageFile.length >= imageNum ? null : uploadButton}
                                        </Upload>
                                    </Form.Item>
                                </div>
                            </div>
                        </div>
                        <div className="websiteSysRow">
                            <div className="websiteSysCol">
                                <div className="websiteSysParam mustFill">Office Address</div>
                                <div className="websiteSysInputMax">
                                    <Form.Item
                                        name="companyLocation"
                                        rules={[
                                            { required: true, message: "Office Address is required." },
                                        ]}
                                    >
                                        <TextArea maxLength={1000} rows={3} placeholder='To be provided by Industry Partner' />
                                    </Form.Item>
                                </div>
                            </div>
                        </div>
                        <div className="websiteSysRow">
                            <div className="websiteSysCol">
                                <div className="websiteSysParam mustFill">Company Description</div>
                                <div className="websiteSysInputMax">
                                    <div id="editor" className="editor"></div>
                                </div>
                            </div>
                        </div>
                        {/* <div className="websiteSysRow">
                            <div className="websiteSysCol">
                                <div className="websiteSysParam mustFill">THEi Requestor Name</div>
                                <div className="websiteSysInput">
                                    <Form.Item
                                        name="theiContactName"
                                        rules={[
                                            { required: true, message: "THEi Requestor Name is required." },
                                        ]}
                                    >
                                        <Input type="text" placeholder="THEi Requestor Name" maxLength={40} />
                                    </Form.Item>
                                </div>
                            </div>
                            <div className="websiteSysCol">
                                <div className="websiteSysParam mustFill">THEi Requestor Department</div>
                                <div className="websiteSysInput">
                                    <Form.Item
                                        name="theiDeptId"
                                        rules={[
                                            { required: true, message: "THEi Requestor Department is required." },
                                        ]}
                                    >
                                        <Select className='sysSelect'>
                                            <Option value=""></Option>
                                            {deptList.map((item) => <Option key={item.deptId} value={item.deptId}>{item.deptCode + "-" + item.deptDisplayName}</Option>)}
                                        </Select>
                                    </Form.Item>
                                </div>
                            </div>
                        </div> */}
                        <div className="websiteSysRow">
                            <div className="websiteSysCol">
                                <div className="websiteSysParam">Industry Partner ID</div>
                                <div className="websiteSysInput">{partnerModel.partnerContactAcctId}</div>
                            </div>
                            <div className="websiteSysCol">
                                <div className="websiteSysParam">Account status</div>
                                <div className="websiteSysInput">{ContextHandler.getMapValue('activeMap', partnerModel.activeInd)}</div>
                            </div>
                        </div>
                        <div className="websiteSysRow">
                            <div className="websiteSysCol">
                                <div className="websiteSysParam">Date of Last Job Post</div>
                                <div className="websiteSysInput">{partnerModel.dateOfLastJobPost ? moment(partnerModel.dateOfLastJobPost).format(Config.dateFormatEn) : ''}</div>
                            </div>
                            <div className="websiteSysCol">
                                <div className="websiteSysParam">Total Number of Job Posts</div>
                                <div className="websiteSysInput">{partnerModel.totalNumberOfJobPosts}</div>
                            </div>
                        </div>
                        <div className="websiteSysRow">
                            <div className="websiteSysCol">
                                <div className="websiteSysParam mustFill">Name</div>
                                <div className="websiteSysInput">
                                    <Form.Item
                                        name="contactName"
                                        rules={[
                                            { required: true, message: "Name is required." },
                                        ]}
                                    >
                                        <Input type="text" placeholder="Name" maxLength={50} />
                                    </Form.Item>
                                </div>
                            </div>
                            <div className="websiteSysCol">
                                <div className="websiteSysParam ">Title</div>
                                <div className="websiteSysInput">
                                    <Form.Item
                                        name="contactTitle"
                                    >
                                        <Input type="text" placeholder="Title" maxLength={80} />
                                    </Form.Item>
                                </div>
                            </div>
                        </div>
                        <div className="websiteSysRow">
                            <div className="websiteSysCol">
                                <div className="websiteSysParam ">Department</div>
                                <div className="websiteSysInput">
                                    <Form.Item
                                        name="contactDept"
                                    >
                                        <Input type="text" placeholder="Department" maxLength={40} />
                                    </Form.Item>
                                </div>
                            </div>
                            <div className="websiteSysCol">
                                <div className="websiteSysParam ">Office Phone</div>
                                <div className="websiteSysInput">
                                    <Form.Item
                                        name="contactOfficePhone"
                                    >
                                        <Input type="text" placeholder="Office Phone" maxLength={12} />
                                    </Form.Item>
                                </div>
                            </div>
                        </div>
                        <div className="websiteSysRow">
                            <div className="websiteSysCol">
                                <div className="websiteSysParam">Mobile</div>
                                <div className="websiteSysInput">
                                    <Form.Item
                                        name="contactMobilePhone"
                                        rules={[
                                            { required: false },
                                        ]}
                                    >
                                        <Input type="text" placeholder="Mobile" maxLength={12} />
                                    </Form.Item>
                                </div>
                            </div>
                            <div className="websiteSysCol">
                                <div className="websiteSysParam mustFill">Email</div>
                                <div className="websiteSysInput">
                                    <Form.Item
                                        name="contactEmail"
                                        rules={[
                                            { required: true, message: "Email is required." },
                                        ]}
                                    >
                                        <Input type="text" placeholder="Email" maxLength={200} />
                                    </Form.Item>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="websiteSysButtonBox">
                        <div className='websiteSysButton' onClick={() => jump('/partner/partnerChangePassword')}>Change Password</div>
                        <div className='websiteSysButton' onClick={() => update()}><img src={saveImg} />Save</div>
                    </div>
                </Form>
            </Spin>
        </div>
    )

}

export default PartnerDetail;